import { useState, useRef, useEffect } from 'react';
import o, { keyframes, css } from 'styled-components';
import { jsx, jsxs } from 'react/jsx-runtime';

var l=o.svg.attrs({x:"0px",y:"0px",viewBox:"0 0 86 107.4",style:{enableBackground:"new 0 0 86 107.4"},children:jsx("g",{children:jsxs("g",{children:[jsx("g",{children:jsx("path",{className:"st0",d:`M37.7,58.6l30.1,47.1c0.8,1.1,1.9,1.7,3.3,1.7h11.1c2.1,0,3.8-1.7,3.8-3.8V3.8c0-3.6-4.5-5.2-6.9-2.4
				L37.7,54C36.8,55.2,36.8,57.2,37.7,58.6z`})}),jsx("g",{children:jsx("path",{className:"st0",d:`M3.9,107.3h19.8c2.1,0,3.8-1.7,3.8-3.8V78.2c0-3.6-4.5-5.2-6.9-2.4L0.8,101.1
				C-1.1,103.8,0.8,107.3,3.9,107.3z`})})]})})})`
  .st0 {
    fill: #fff;
  }
`;var p=keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
`,I=keyframes`
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.2);
  }
`,R=keyframes`
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
`,W=r=>keyframes`
  0% {
    left: 18px;
    ${r}: 18px;
  }
  100% {
    left: 18px;
    ${r}: 42px;
  }
`,L=r=>keyframes`
  0% {
    background: transparent;
    border: 4px solid transparent;

    ${r==="top"?"border-bottom-color: var(--color-blurple-600);":"border-top-color: var(--color-blurple-600);"}
  }
  100% {
    background: transparent;
    border: 4px solid transparent;
    height: 50px;
    left: -5px;
    width: 50px;

    ${r}: -2px;

    ${r==="top"?"border-bottom-color: var(--color-blurple-600);":`border-top-color: var(--color-blurple-600);
          `}
  }
`,i=o.div`
  display: grid;
  grid-template-columns: 1fr;
`,c=o.div`
  animation: ${p} 0.6s ease-in-out 1, ${R} 1.5s linear 0.5s infinite;
  background: var(--gradient-blurple);
  border-radius: 50%;
  display: block;
  grid-column-start: 1;
  grid-row-start: 1;
  height: 40px;
  position: relative;
  transform: translateZ(0);
  width: 40px;
  will-change: transform;
`,s=o.div`
  background: var(--color-blurple-600);
  border-radius: 50%;
  height: 6px;
  left: 18px;
  position: absolute;
  width: 6px;
  transform: translateZ(0);
  will-change: transform;

  ${({$position:r})=>css`
    animation: ${W(r)} 0.5s linear 1 0.5s forwards,
      ${L(r)} 0.5s linear 1 1s forwards,
      ${I} 0.5s linear 1 3s forwards;

    ${r}: 18px;
  `}
`,d=o.div`
  align-items: center;
  animation: ${p} 0.6s ease-in-out 1;
  background: var(--gradient-blurple);
  border-radius: 100%;
  display: flex;
  grid-column-start: 1;
  grid-row-start: 1;
  height: 40px;
  justify-content: center;
  position: absolute;
  transform: translateZ(0);
  width: 40px;
  will-change: transform;
`,f=o(l)`
  width: 20px;
  height: 20px;
`;var m=()=>{let[r,u]=useState(0),b=useRef(null),x=useRef(null),h=useRef(null);return useEffect(()=>{let v=setInterval(()=>u(w=>w>0?0:1),3600);return ()=>{clearInterval(v);}},[r]),jsxs(i,{role:"progressbar","aria-label":"Loading","aria-busy":!0,"aria-live":"polite",children:[jsxs(c,{ref:b,children:[jsx(s,{$position:"top",ref:x}),jsx(s,{$position:"bottom",ref:h})]}),jsx(d,{children:jsx(f,{})})]},r)};m.displayName="Spinner";var V=m;

export { V as a };
